import React from 'react';

interface StartPageProps {
    onMount: () => void;
}

const StartPage: React.FC<StartPageProps> = ({ onMount }) => {
    React.useEffect(() => {
        onMount();
    }, [onMount]);

    return <></>;
};

export default React.memo(StartPage);
